import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/primeng';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent implements OnInit {
  @Input() key: string;
  @Input() message: string;
  @Output() accept = new EventEmitter<void>();
  @Output() reject = new EventEmitter<void>();

  constructor(
    private confirmationService: ConfirmationService,
    private translateService: TranslateService,
    ) {

    this.translateService.get('confirmation_message').subscribe((message) => {
      this.message = this.message ? this.message : message;
    });
    
  }

  ngOnInit() {}

  confirm() {
    this.confirmationService.confirm({
        key: this.key,
        message: this.message,
        accept: () => {
          this.accept.emit();
        },
        reject: () => {
          this.reject.emit();
        }
    });
}
  translate = (key: string) => this.translateService.instant(key || "invalid");

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/confirm/confirm.component.ts